import { isWeb } from "./platform";
import { LOGGING_ENDPOINT_URL, ERROR_ENDPOINT_TOKEN, isDemo, isDevelopment } from "../constants/settings";

export interface ErrorReport {
  /** The message that gets indexed as the log line. */
  errorLog: string;
  /** Result of GetUserProfile(). Passed in rather than read here so this module
   *  stays free of ./general - error-boundary.tsx already imports from there. */
  user?: any;
  backendEndpoint?: string;
  additionalPayload?: any;
  severityLevel?: number;
}

/**
 * Fire-and-forget POST to the error collection endpoint.
 *
 * Never throws and never hands back a promise the caller has to handle -
 * reporting a problem must not turn into a second problem. Suppressed in
 * development so local noise stays out of the production error collection.
 */
export const ReportError = ({
  errorLog,
  user,
  backendEndpoint = "",
  additionalPayload,
  severityLevel = 10,
}: ErrorReport) => {
  try {
    if (isDevelopment) return;

    // An axios error graph is circular, so a failed stringify must not sink the report
    let payload = "{}";
    try {
      payload = typeof additionalPayload === "string"
        ? additionalPayload
        : JSON.stringify(additionalPayload ?? {});
    } catch {
      payload = "[unserializable payload]";
    }

    const errorData = {
      project_name: `CMASA_ADMIN_${isDemo ? "STAGING" : "PROD"}`,
      stack: "react",
      username: user ? `${user?.username} (${user?.id})` : "Unknown",
      timestamp: new Date().toISOString(),
      severity_level: severityLevel,
      page_url: isWeb ? window.location.href : "",
      backend_endpoint: backendEndpoint,
      error_log: errorLog,
      additional_payload: payload,
      user_token: user?.token || "",
    };

    fetch(LOGGING_ENDPOINT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${ERROR_ENDPOINT_TOKEN}`,
      },
      body: JSON.stringify(errorData),
    }).catch((err) => console.error('Error reporting failed:', err));
  } catch (err) {
    console.error('Error reporting failed:', err);
  }
};
